/*
 * FilthyBass — cart drawer cross-sell rail.
 *
 * The rail markup lives in snippets/fb-cart-upsell.liquid and is re-rendered
 * server-side by cart-drawer.js on every cart change, so this file only has to
 * handle the one-tap add. Same add-then-rerender pattern as <fb-bundle-builder>
 * in sections/product-bundle.liquid.
 *
 * Loaded from snippets/cart-drawer.liquid, which sits OUTSIDE .drawer__inner —
 * innerHTML replacement does not execute <script>, so the element must be
 * defined from a real asset, not inline.
 */
if (!customElements.get('fb-cart-upsell')) {
  class FBCartUpsell extends HTMLElement {
    connectedCallback() {
      // The element is recreated on every drawer re-render, so a fresh listener
      // each time is correct — there is nothing to de-duplicate.
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const toggle = event.target.closest('[data-fb-upsell-sizes]');
      if (toggle) {
        event.preventDefault();
        this.toggleSizes(toggle);
        return;
      }
      const button = event.target.closest('[data-fb-upsell-add]');
      if (!button) return;
      event.preventDefault();
      this.add(button);
    }

    // Multi-variant products pick their size inside the drawer. Navigating to
    // the PDP would close the drawer and lose the tier progress the shopper is
    // part-way through.
    // The size rows sit full width under the cards (a card is too narrow for
    // one); each button names its row with aria-controls.
    toggleSizes(toggle) {
      const id = toggle.getAttribute('aria-controls');
      const sizes = id && this.querySelector(`#${CSS.escape(id)}`);
      if (!sizes) return;

      const opening = sizes.hidden;
      // Only one size row open at a time, so the drawer footer stays put.
      this.querySelectorAll('.fb-cart-rail__sizes').forEach((el) => {
        el.hidden = true;
      });
      this.querySelectorAll('[data-fb-upsell-sizes]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });

      sizes.hidden = !opening;
      toggle.setAttribute('aria-expanded', String(opening));
      if (opening) {
        const first = sizes.querySelector('.fb-cart-rail__size:not([disabled])');
        if (first) first.focus();
      }
    }

    add(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.hasAttribute('aria-busy')) return;

      const error = this.querySelector('.fb-cart-rail__error');
      if (error) error.hidden = true;

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message);
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          // Replaces this element too, so nothing below this line can rely on `this`.
          cart.renderContents(response);
          if (cart.open) cart.open();
        })
        .catch((err) => {
          console.error('[fb-cart-upsell]', err);
          button.removeAttribute('aria-busy');
          button.disabled = false;
          if (error) {
            error.textContent = window.cartStrings ? window.cartStrings.error : '';
            error.hidden = false;
          }
        });
    }
  }

  customElements.define('fb-cart-upsell', FBCartUpsell);
}
